import { useStateContext } from "../state";
import { FormatOptions } from "./FormatOptions";
import { SampleOptions } from "./SampleOptions";
import { InferOptions } from "./InferOptions";
import { DirReaderOptions } from "./DirReaderOptions";

export { Button as ShowAdvancedOptionsButton } from "./Button";

export const AdvancedOptions = () => {
  const { files } = useStateContext();
  return (
    <div className="flex flex-col gap-6">
      <SampleOptions />
      {files.length > 1 ? <DirReaderOptions /> : <FormatOptions />}
      <InferOptions />
    </div>
  );
};
